module.exports = __webpack_public_path__ + "static/media/g_yellow.f5d00169.svg";